import { useEffect, useReducer, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import { getTheme } from "../highChartTheme";

import * as actions from "../../../actions/multiSurvey";
import multiSurveyReducer from "../../../reducers/multiSurvey";
import React from "react";

type RunChartProps = {
  tierId: number;
  surveyId: number;
  surveyName: string;
  isRefreshDataRequired: object;
};

type RunchartDataObj = {
  tierId: number;
  xaxis: string;
  percentage: number;
  target: number;
  actual: number;
  totalTarget: number;
  yearNo: number;
  mName: string;
  msDate: string;
};

const initState = { runChartData: [] };

const RunChart = (props: RunChartProps) => {
  const { tierId, surveyId, surveyName, isRefreshDataRequired } = props;

  const isLightMode = useSelector((state: any) => state.theme.lightMode);

  const [state, dispatch] = useReducer(multiSurveyReducer, initState);

  const [animate, setAnimate] = useState<string>("");

  const { runChartData } = state;

  useEffect(() => {
    if (surveyId)
      actions.getRunChartData(dispatch, {
        tierId,
        surveyId,
        date: moment().format("YYYY-MM-DD"),
      });
  }, [surveyId, isRefreshDataRequired]);

  useEffect(() => {
    setTimeout(() => {
      setAnimate("animate");
    }, 250);
  }, [runChartData]);

  const options = {
    chart: {
      backgroundColor: "transparent",
      type: "line",
    },
    series: [
      {
        name: "Target %",
        type: "line",
        lineWidth: 2,
        legendcolor: "#FFFFFF",
        data: runChartData.map((x1: RunchartDataObj) => x1.totalTarget),
        color: "#FFFFFF",
      },
      {
        name: "Survey Attainment %",
        type: "line",
        lineWidth: 4,
        legendcolor: "#1b9fef",
        data: runChartData.map((x1: RunchartDataObj) => x1.percentage),
        color: "#1b9fef",
      },
    ],
  };

  return (
    <div className="site-view tier-wrap admin-console-wrapper">
      <div
        className={"site-list " + animate}
        style={{
          backgroundColor: isLightMode ? "#d3d3d3" : "#2f3030",
        }}
      >
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            ...options,
            ...getTheme(
              `${surveyName ? surveyName + " :" : ""}  Run Chart`,
              isLightMode,
              runChartData.map((x1: RunchartDataObj) => x1.xaxis)
            ),
          }}
        />
      </div>
    </div>
  );
};

export default RunChart;
